export const BEACON_POST_MODE_TOGGLE = 'BEACON_POST_MODE_TOGGLE';
export const BEACON_POST_OVERFLOW_MENU = 'BEACON_POST_OVERFLOW_MENU';
export const BEACON_POST_TOPIC_BAR = 'BEACON_POST_TOPIC_BAR';
export const BEACON_POST_VIEW_HISTORY = 'BEACON_POST_VIEW_HISTORY';

export const BEACON_TOPIC_BANNER = 'BEACON_TOPIC_BANNER';
export const BEACON_TOPIC_EDIT = 'BEACON_TOPIC_EDIT';
export const BEACON_TOPIC_EDIT_MODAL = 'BEACON_TOPIC_EDIT_MODAL';
export const BEACON_TOPIC_MEMBERS = 'BEACON_TOPIC_MEMBERS';
export const BEACON_TOPIC_OVERFLOW_MENU = 'BEACON_TOPIC_OVERFLOW_MENU';
export const BEACON_TOPIC_SIDEBAR = 'BEACON_TOPIC_SIDEBAR';

export const BEACON_SEARCH_INPUT = 'BEACON_SEARCH_INPUT';
export const BEACON_SEARCH_POSTS = 'BEACON_SEARCH_POSTS';
export const BEACON_SEARCH_TARGETS = 'BEACON_SEARCH_TARGETS';

export const TUTORIAL_NAME_POST = 'POST_TUTORIAL';
export const TUTORIAL_NAME_SEARCH = 'SEARCH_TUTORIAL';
export const TUTORIAL_NAME_TOPIC = 'TOPIC_TUTORIAL';

export const SUBJECT_ORG_ONBOARDING = 'ORG_ONBOARDING';
